export const resetDownloadUserPassword = async (token, newPassword) => {
  const endpoint = "/user/download-password-reset.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token, newPassword }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(
        data?.error?.message ||
          data?.message ||
          `Error ${res.status}: ${res.statusText}`,
      );
    }
    if (data.success === false) {
      throw new Error(
        data?.error?.message || data?.message || "Password reset failed",
      );
    }
    return data;
  } catch (err) {
    console.error("resetDownloadUserPassword error:", err);
    throw err;
  }
};

export const checkPasswordStrength = async (
  password,
  setPassStrength,
  setPwdSuggestion,
) => {
  const endpoint = "/user/check-password.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ password }),
    });

    const data = await res.json();
    const payload = data?.data;

    if (setPassStrength) setPassStrength(payload?.strength ?? null);
    if (setPwdSuggestion) {
      let suggestion = "";
      if (payload?.valid) {
        suggestion = payload?.message || "";
      } else {
        const details = payload?.details ? payload.details + "; " : "";
        suggestion = details + (payload?.message || "");
      }
      setPwdSuggestion(suggestion);
    }
    return payload ?? null;
  } catch (err) {
    console.error("checkPasswordStrength error:", err);
    return null;
  }
};
